import { createContext } from 'react';

const EventRegistrationContext = createContext(null);

export default EventRegistrationContext;
